import { StyleSheet, Text } from '@react-pdf/renderer';
import React from 'react';

import { CarrierFactory } from '../../../../../../common/carrierConfig/carrierFactory';
import { Carriers } from '../../../../../../common/constants/carriers';

export interface ReinstatementWithdrawalContentProps {
  carrier: Carriers;
}

const ReinstatementWithdrawalContent = ({
  carrier,
}: ReinstatementWithdrawalContentProps) => (
  <>
    <Text style={styles.text}>
      Thank you for applying for life insurance with{' '}
      {CarrierFactory.getCarrierConfig(carrier)?.getCarrierDisplayName()}.
    </Text>
    <Text style={styles.text}>
      To date, we have not received all of the requirements necessary to review
      for your application. Therefore, we are unable to process your request for
      reinstatement at this time.
    </Text>
    <Text style={styles.text}>
      If applicable, a refund check for back premium will follow in a separate
      envelope. This policy is no longer in force - there is no insurance in
      force.
    </Text>
  </>
);

const styles = StyleSheet.create({
  text: {
    fontSize: 10,
    lineHeight: 1.4,
    marginBottom: 12,
  },
  bold: {
    fontWeight: '700',
  },
});

export default ReinstatementWithdrawalContent;
